import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from './shared/services/auth.service';
import { ClientVersionService } from './shared/services/client-version.service';
import { SnackBarService } from './shared/services/snackBar.service';
import { LocalizationService } from './shared/services/localization.service';
import { SessionStorageService } from './shared/services/session-storage.service';
import { IdleState } from './app-settings';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  // * it's not used per se, but I want to have it, maybe it will be useful some time later
  idleState: IdleState = IdleState.UNKNOWN;

  private readonly bodyClass = 'fliko';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private idle: Idle,
    private router: Router,
    private authService: AuthService,
    private snackBarService: SnackBarService,
    private matDialog: MatDialog,
    private ls: LocalizationService,
    private sessionStorageSrv: SessionStorageService,
    changeDetector: ChangeDetectorRef,
    private clientVersion: ClientVersionService
  ) {
    const userID = this.sessionStorageSrv.selectedUser.get();

    if (!userID) {
      authService.logOut();
    }

    idle.setIdle(10); // how long can they be inactive before considered idle, in seconds
    idle.setTimeout(3600); // how long can they be idle before considered timed out, in seconds
    // provide sources that will "interrupt", meaning user activity events
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleStart.subscribe(() => (this.idleState = IdleState.IDLE));

    idle.onIdleEnd.subscribe(() => {
      this.idleState = IdleState.NOT_IDLE;
      changeDetector.detectChanges();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = IdleState.TIMED_OUT;
      this.authService.logOut().then(() => {
        this.matDialog.closeAll();
        this.router.navigate(['/signIn']);
      });
      this.snackBarService.showInfo(this.ls.translate('context.timeOut'), 'OK');
    });
  }

  ngOnInit(): void {
    this.clientVersion.initialize();
    this.renderer.addClass(this.document.body, this.bodyClass);
    this.reset();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, this.bodyClass);
  }

  private reset(): void {
    this.idle.watch();
    this.idleState = IdleState.NOT_IDLE;
  }
}
